import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackData } from './snack-data.model';
import { MatButtonModule } from '@angular/material/button';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-snack',
  imports: [
    MatIconModule,
    MatButtonModule,
    ClipboardModule,
    MatTooltipModule,
  ],
  templateUrl: './snack.component.html',
  styleUrl: './snack.component.scss'
})
export class SnackComponent {
  readonly data = inject<SnackData>(MAT_SNACK_BAR_DATA);
}
